import {} from '@routable/tablematic';
import _get from 'lodash/get';
import _set from 'lodash/set';
import { getLineItemsPathFromStyle } from 'helpers/lineItems';
import {} from './overlays.models';
export const flattenOverlayDataBySource = (overlaysData, source = 'ocr') => {
    return Object.entries(overlaysData || {}).reduce((acc, [key, value]) => {
        if (key === 'lineItems') {
            const transformedLineItems = overlaysData.lineItems?.map((lineItem) => flattenOverlayDataBySource(lineItem));
            acc.lineItems = transformedLineItems;
            return acc;
        }
        const ocrValueFromOverlay = value.find((overlay) => overlay.source === source)?.value;
        return {
            ...acc,
            [key]: ocrValueFromOverlay,
        };
    }, {});
};
const extractLineItemLabels = (mapping) => {
    return Object.entries(mapping).reduce((acc, [key, fieldPath]) => {
        const [, lineItemValueKey] = fieldPath.split('.');
        acc[key] = lineItemValueKey;
        return acc;
    }, {
        accountId: 'account_id',
        itemId: 'item_id',
    });
};
const setValues = ({ fieldPath, initialValues, initialValuesWithSources, ocrValuesFromOverlays }) => {
    const ocrValue = ocrValuesFromOverlays[0].value;
    if (fieldPath.includes('extended_') &&
        typeof ocrValue === 'object' &&
        !('id' in ocrValue) &&
        'value' in ocrValue) {
        const ocrValuesFromOverlaysMapped = ocrValuesFromOverlays.map((ocrVal) => ({
            ...ocrVal,
            value: ocrVal.value.value,
        }));
        _set(initialValues, fieldPath, ocrValue.value);
        _set(initialValuesWithSources, fieldPath, ocrValuesFromOverlaysMapped);
    }
    else {
        _set(initialValues, fieldPath, ocrValue);
        _set(initialValuesWithSources, fieldPath, ocrValuesFromOverlays);
    }
};
export const transformOverlayDataWithFieldMapping = (fieldMapping, overlaysData) => {
    const initialValues = {};
    const initialValuesWithSources = {};
    if (!overlaysData || !fieldMapping) {
        return {
            initialValues,
            initialValuesWithSources,
        };
    }
    Object.entries(fieldMapping).forEach(([fieldKey, fieldPath]) => {
        if (fieldKey === 'lineItem') {
            const lineItemMappingLabels = extractLineItemLabels(fieldPath);
            const transformedLineItemsWithSources = (overlaysData.lineItems || [])?.map((lineItem) => transformOverlayDataWithFieldMapping(lineItemMappingLabels, lineItem).initialValuesWithSources);
            const transformedLineItems = [];
            const lineItems = { line_items: {} };
            transformedLineItemsWithSources.forEach((lineItem) => {
                const lineItemWithInitialValues = {};
                const lineItemWithSources = {};
                const lineItemStyle = lineItem.style[0].value;
                const path = getLineItemsPathFromStyle(lineItemStyle);
                Object.keys(lineItem).forEach((key) => {
                    const ocrValuesFromOverlays = lineItem[key];
                    if (ocrValuesFromOverlays) {
                        setValues({
                            fieldPath: key,
                            initialValues: lineItemWithInitialValues,
                            initialValuesWithSources: lineItemWithSources,
                            ocrValuesFromOverlays,
                        });
                    }
                });
                const currVal = _get(lineItems, path) || [];
                currVal.push(lineItemWithSources);
                _set(lineItems, path, currVal);
                transformedLineItems.push(lineItemWithInitialValues);
            });
            _set(initialValues, 'overlayLineItems', transformedLineItems);
            _set(initialValuesWithSources, 'line_items', lineItems.line_items);
            return;
        }
        const ocrValuesFromOverlays = overlaysData[fieldKey];
        if (ocrValuesFromOverlays) {
            setValues({
                fieldPath,
                initialValues,
                initialValuesWithSources,
                ocrValuesFromOverlays,
            });
        }
    }, {});
    return {
        initialValues,
        initialValuesWithSources,
    };
};
